"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _reduxForm = require("redux-form");

var _addressSettingsFormValidation = require("utils/addressSettingsFormValidation");

var _recompose = require("recompose");

var _AddressSettingsForm = require("@quixeltools/quixel-ui-library/dist/components/common/checkout/AddressSettingsForm");

var _AddressSettingsForm2 = _interopRequireDefault(_AddressSettingsForm);

var _euCountries = require("@quixeltools/quixel-ui-library/dist/utils/euCountries");

var _euCountries2 = _interopRequireDefault(_euCountries);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isEUCountry = _ramda2.default.contains(_ramda2.default.__, _euCountries2.default);

var AddressSettingsFormContainer = function AddressSettingsFormContainer(props) {
  return _react2.default.createElement(_AddressSettingsForm2.default, {
    paypalContainerId: props.paypalContainerId,
    fields: props.fields,
    error: props.errorMsg,
    message: props.message,
    handleSubmit: props.handleSubmit,
    updating: props.updating,
    lockCountryAndVat: isEUCountry(props.fields.country.value),
    validatingVat: false
  });
};

exports.default = (0, _reduxForm.reduxForm)({
  fields: ["name", "company", "address", "postalCode", "city", "country", "vatNo", "state", "address2"],
  form: "Address Settings",
  validate: _addressSettingsFormValidation.validate
})((0, _recompose.lifecycle)({
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    if (this.props.fields.state.value !== nextProps.fields.state.value) {
      this.props.fields.city.onChange({ value: '', name: '' });
    }

    if (this.props.fields.country.value !== nextProps.fields.country.value) {
      this.props.fields.state.onChange({ value: '', name: '' });
      this.props.fields.city.onChange({ value: '', name: '' });
    }
    //console.log(nextProps)
  }
})(AddressSettingsFormContainer));
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AddressSettingsForm/AddressSettingsForm.jsx
// module id = 2542
// module chunks = 0